import {AbstractDiscoStandardMapper} from "../abstract-disco-standard.mapper";

export class FrDiscoCafSynthesisMapper extends AbstractDiscoStandardMapper {
}
